export default function TextInput({ inputName, placeholder, label, value, handleChange, handleDelete, index, isFirst, isBig, width = null, isLast = false }) {
    return (
        <div className="flex w-full gap-2 items-center">
            <div className={`flex w-full items-center mb-5 ${isFirst ? "first:ml-2" : ""}`}>
                {label ? <label htmlFor={inputName} className="text-[14px] text-[#7A7A7A] w-28 inline-block text-right mr-4">{label}</label>
                    : null}
                <input
                    onChange={handleChange}
                    name={inputName}
                    id={inputName}
                    type="text"
                    value={value}
                    placeholder={placeholder}
                    onFocus={(e) => e.target.placeholder = ""}
                    onBlur={(e) => e.target.placeholder = `${placeholder ? placeholder : ""}`}
                    className={`${isBig ? "p-2 py-4" : "p-2"} placeholder:text-sm rounded-lg border-2 border-gray-400 flex-1 placeholder-gray-300 outline-none focus:border-main-color transition duration-500`}
                    style={{ width: `${width}px` }}
                />

            </div>
            {
                isLast
                    ?
                    <div className="cursor-pointer select-none flex bg-red-600 w-8 h-8 justify-center items-center rounded-full text-white mb-5" onClick={() => { handleDelete(index) }}>
                        X
                    </div>
                    :
                    null
            }
        </div>
    )
}